import { useState } from "react";

const PAGE_SIZE = 25;

export default function CycleExecutionsTable({ executions }) {
  const [page, setPage] = useState(1);

  const start = (page - 1) * PAGE_SIZE;
  const pageData = executions.slice(start, start + PAGE_SIZE);
  const totalPages = Math.ceil(executions.length / PAGE_SIZE);

  return (
    <>
      <div className="execution-table-wrapper">
      <table className="execution-table">
        <thead>
          <tr>
            <th>Issue Key</th>
              <th>Status</th>
              <th>Summary</th>
              <th>Defects</th>
              <th>Labels</th>
              <th>Executed By</th>
              <th>Executed On</th>
              <th>Assignee</th>
          </tr>
        </thead>

          <tbody>
            {pageData.map((e) => (
              <tr key={e.executionId}>
                <td className="issue-key">{e.testKey}</td>

                <td>
                  <span
                    className="status-pill"
                    style={{ color: e.statusColor, backgroundColor: e.statusColor + "19" }}
                  >
                    {e.status}
                  </span>
                </td>

                <td className="summary-cell">{e.testSummary}</td>

                <td>
                  {e.defects?.length > 0 ? (
                    <span className="defect-badge">
                      {e.defects.map((d) => d.key).join(", ")}
                    </span>
                  ) : (
                    "-"
                  )}
                </td>

                <td>{e.testLabels || "-"}</td>
                <td>{e.executedBy || "-"}</td>
                <td>{e.executedOnDisplay || "-"}</td>
                <td>{e.assignedTo || "-"}</td>
              </tr>
            ))}
          </tbody>
      </table>
</div>
      <div className="pagination">
        <button disabled={page === 1} onClick={() => setPage(p => p - 1)}>
          Prev
        </button>

        <span>
          Page {executions.length > 0 ? page : 0} of {totalPages}
        </span>

       <button
          disabled={executions.length > 0 ? page === totalPages: true}
          onClick={() => setPage((p) => p + 1)}
        >
          Next
        </button>
      </div>
    </>
  );
}